import { Link, useNavigate } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import AuthApiManager from '../../api/services/AuthApiManager'
import { set } from 'react-hook-form'
import Avatar from 'react-avatar'
import { useTranslation } from 'react-i18next'

function HorizontalNavbarCustom() {
    const { t, i18n } = useTranslation()
    const [username, setUsername] = useState(() => {
        var userData = localStorage.getItem('userData')
        if (userData) {
            return JSON.parse(userData)?.username
        }

        return t('user')
    })

    const [avatar, setAvatar] = useState(() => {
        var userData = localStorage.getItem('userData')

        if (userData) {
            return JSON.parse(userData)?.avatar
        }

        return ''
    })

    const [operator, setOperator] = useState(() => {
        var operatorData = localStorage.getItem('operador')

        if (operatorData) {
            return JSON.parse(operatorData)?.group_name
        }

        return ''
    })
    const [hasPermission, setHasPermission] = useState(false)

    const navigate = useNavigate()
    useEffect(() => {
        var operatorData = localStorage.getItem('operador')

        if (operatorData) {
            const opName = JSON.parse(operatorData)?.group_name
            setOperator(opName)
        }
        setHasPermission(AuthApiManager.hasPermission('Operador'))
        // Horizontal menu fixed when scrolling
        window.addEventListener('scroll', function () {
            let navbar = document.querySelector('.horizontal-menu')
            let body = document.querySelector('body')
            if (window.scrollY >= 70) {
                navbar.classList.add('fixed-on-scroll')
                body.classList.add('horizontal-menu-fixed-on-scroll')
            } else {
                navbar.classList.remove('fixed-on-scroll')
                body.classList.remove('horizontal-menu-fixed-on-scroll')
            }
        })

        // Horizontal menu navigation in mobile menu on click
        let navItemClicked = document.querySelectorAll(
            '.horizontal-menu .page-navigation >.nav-item'
        )
        navItemClicked.forEach(function (el) {
            el.addEventListener('click', function () {
                var result = [],
                    node = this.parentNode.firstChild
                while (node) {
                    if (node !== this) result.push(node)
                    node = node.nextElementSibling || node.nextSibling
                }
                result.forEach((el) => el.classList.remove('show-submenu'))
                this.classList.toggle('show-submenu')
            })
        })
    })

    const isPathActive = (path) => {
        return location.pathname.startsWith(path)
    }

    const toggleBottomMenu = () => {
        document
            .querySelector('.bottom-navbar')
            .classList.toggle('header-toggled')
    }

    const toggleRightSidebar = () => {
        document.querySelector('.right-sidebar').classList.toggle('open')
    }

    const handleLogout = () => {
        localStorage.removeItem('userData')
        localStorage.clear()
        navigate('/user-pages/login')
    }

    return (
        <>
            <div className="horizontal-menu">
                <nav className="navbar top-navbar default-layout-navbar col-lg-12 col-12 p-0 d-flex flex-row">
                    <div className="container">
                        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                            <Link
                                className="navbar-brand brand-logo-mini"
                                to="/"
                            >
                                <img src="/images/OkTvBlanco.png" alt="logo" />
                            </Link>
                        </div>
                        <div className="navbar-menu-wrapper d-flex align-items-stretch justify-content-end">
                            <ul className="navbar-nav mr-lg-2">
                                <li className="nav-item nav-language">
                                    <Dropdown align={'end'}>
                                        <Dropdown.Toggle className="nav-link">
                                            {i18n.resolvedLanguage === 'es' ? (
                                                <span className="fi fi-es"></span>
                                            ) : (
                                                <span className="fi fi-us"></span>
                                            )}
                                            
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="navbar-dropdown">
                                            <Dropdown.Item
                                                href="!#"
                                                onClick={(evt) => {
                                                    evt.preventDefault()
                                                    i18n.changeLanguage('es')
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontWeight:
                                                            i18n.resolvedLanguage ===
                                                            'es'
                                                                ? 'bold'
                                                                : 'normal',
                                                    }}
                                                >
                                                    <span class="fi fi-es"></span>
                                                    &nbsp;{t('spanish')}
                                                </span>
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="!#"
                                                onClick={(evt) => {
                                                    evt.preventDefault()
                                                    i18n.changeLanguage('en')
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontWeight:
                                                            i18n.resolvedLanguage ===
                                                            'en'
                                                                ? 'bold'
                                                                : 'normal',
                                                    }}
                                                >
                                                    <span class="fi fi-us"></span>
                                                    &nbsp;{t('english')}
                                                </span>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                            </ul>
                            <ul className="navbar-nav navbar-nav-right">
                                <li className="nav-item nav-profile">
                                    {operator}{' '}
                                </li>
                                <li className="nav-item nav-profile">
                                    <Dropdown align={'end'}>
                                        <Dropdown.Toggle className="nav-link">
                                            <div className="nav-profile-img">
                                                <Avatar
                                                    name={username}
                                                    size={32}
                                                    src={avatar}
                                                    round={true}
                                                    color="#5995ed"
                                                />
                                            </div>
                                            <div className="nav-profile-text arrow">
                                                <p className="mb-0">
                                                    {' '}
                                                    {username}{' '}
                                                </p>
                                            </div>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="navbar-dropdown">
                                            <Dropdown.Item
                                                href="!#"
                                                onClick={(evt) => {
                                                    evt.preventDefault()
                                                }}
                                            >
                                                <Link
                                                    to="/user/perfil"
                                                    className="text-decoration-none text-dark"
                                                >
                                                    <i className="mdi mdi-account-circle mr-2 text-primary"></i>
                                                    {t('my_profile')}
                                                </Link>
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                href="!#"
                                                onClick={(evt) => {
                                                    evt.preventDefault()
                                                    handleLogout()
                                                }}
                                            >
                                                <i className="mdi mdi-logout mr-2 text-primary"></i>
                                                {t('auth.logout')}
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                            </ul>
                            <button
                                className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                                type="button"
                                onClick={toggleBottomMenu}
                            >
                                <span className="mdi mdi-menu"></span>
                            </button>
                        </div>
                    </div>
                </nav>
                <nav className="bottom-navbar">
                    <div className="container">
                        <ul className="nav page-navigation">
                            <li
                                className={
                                    isPathActive('/dashboard')
                                        ? 'nav-item active'
                                        : 'nav-item'
                                }
                            >
                                <Link
                                    className="nav-link pr-1"
                                    to="/operadores"
                                >
                                    <img
                                        className="mt-1"
                                        src="/images/OkTvBlanco.png"
                                        alt="logo"
                                        width={80}
                                    />
                                </Link>
                            </li>
                            <li
                                className={
                                    isPathActive('/operadores')
                                        ? 'nav-item active'
                                        : 'nav-item'
                                }
                            >
                                <Link className="nav-link" to="/operadores">
                                    <i className="mdi mdi-briefcase menu-icon"></i>
                                    <span className="menu-title">
                                        {t('operators_title')}
                                    </span>
                                </Link>
                            </li>
                            {hasPermission && (
                                <li
                                    className={
                                        isPathActive('/operadores/usuarios')
                                            ? 'nav-item active'
                                            : 'nav-item'
                                    }
                                >
                                    <Link
                                        className="nav-link"
                                        to="/operadores/usuarios"
                                    >
                                        <i className="mdi mdi-account-group menu-icon"></i>
                                        <span className="menu-title">
                                            {t('users_title')}
                                        </span>
                                    </Link>
                                </li>
                            )}
                            <li
                                className={
                                    isPathActive('/operadores/canales')
                                        ? 'nav-item active'
                                        : 'nav-item'
                                }
                            >
                                <Link
                                    className="nav-link"
                                    to="/operadores/canales"
                                >
                                    <i className="mdi mdi-layers menu-icon"></i>
                                    <span className="menu-title">
                                        {t('channels_title')}
                                    </span>
                                </Link>
                            </li>
                            {hasPermission && (
                                <li
                                    className={
                                        isPathActive('/operadores/banners')
                                            ? 'nav-item active'
                                            : 'nav-item'
                                    }
                                >
                                    <Link
                                        className="nav-link"
                                        to="/operadores/banners"
                                    >
                                        <i className="mdi mdi-projector-screen-variant-outline menu-icon"></i>
                                        <span className="menu-title">
                                            {t('banners_title')}
                                        </span>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                </nav>
            </div>
        </>
    )
}

export default HorizontalNavbarCustom
